import { QueueManager } from '@or-sdk/queue-manager';
import _ from 'lodash';

import { useAuth } from '@/stores';

import config from '../config';


const instance = new QueueManager({
  providersAccountId: `${config.PROVIDERS_ACCOUNT_ID}`,
  discoveryUrl: `${config.SERVICE_DISCOVERY_API_URL}`,
  eventManagerUrl: `${config.EVENT_MANAGER_URL}`,
  token: () => {
    return `USER ${_.get(useAuth(), 'token')}`;
  },
});

export default instance;
